import React from 'react';
import { formatNumber, formatDuration } from '../utils/formatters';
import OrbitVisualizer3D from './OrbitVisualizer3D';

const ResultsSection = ({ results, initialOrbit, targetOrbit }) => {
  if (!results) return null;

  const stats = [
    { label: 'Burn 1', value: `${formatNumber(results?.delta_v_burn1 || 0)} m/s`, icon: '↗️' },
    { label: 'Burn 2', value: `${formatNumber(results?.delta_v_burn2 || 0)} m/s`, icon: '↘️' },
    ...(results?.delta_v_burn3 ? [{ label: 'Burn 3', value: `${formatNumber(results.delta_v_burn3)} m/s`, icon: '🔄' }] : []),
    ...(results?.delta_v_inclination > 0.1 ? [{ label: 'Inclination', value: `${formatNumber(results.delta_v_inclination)} m/s`, icon: '📐' }] : []),
    { label: 'Time', value: formatDuration(results?.transfer_time || 0), icon: '⏱️' },
    { label: 'Fuel', value: `${formatNumber(results?.fuel_mass || 0)} kg`, icon: '⛽' },
    { label: 'Mass', value: `${formatNumber(results?.total_mass || 0)} kg`, icon: '⚖️' }
  ];

  return (
    // Умеренная ширина и средние отступы между колонками
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start animate-in fade-in duration-500 max-w-[1200px] mx-auto">
      
      <div className="bg-slate-900 p-7 rounded-2xl border border-slate-700 shadow-xl text-slate-100 h-full flex flex-col">
        
        {/* Header - Умеренно крупный */}
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold tracking-tight">Transfer Results</h3>
          <span className="px-2.5 py-1 bg-blue-500/10 border border-blue-500/40 rounded text-blue-400 text-[11px] font-bold uppercase tracking-wider">
            {results?.transfer_type_used || 'HOHMANN'}
          </span>
        </div>

        {/* Главный Delta-V блок - Акцентный, но не перегруженный */}
        <div className="mb-5 p-5 bg-blue-600/15 border border-blue-500/40 rounded-xl flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-3xl">🚀</span>
            <span className="font-bold text-blue-500 text-base uppercase tracking-wide">Total Delta-V</span>
          </div>
          <span className="text-3xl font-black text-white font-mono">
            {formatNumber(results?.delta_v_total || 0)} <span className="text-sm text-slate-400 font-normal">m/s</span>
          </span>
        </div>

        {/* Сетка параметров - Четкая и компактная */}
        <div className="grid grid-cols-2 gap-3.5">
          {stats.map((item, index) => (
            <div key={index} className="p-4 bg-slate-800/40 border border-slate-700/60 rounded-xl flex flex-col hover:border-slate-500 transition-colors">
              <div className="flex items-center gap-2 text-slate-500 mb-1">
                <span className="text-base">{item.icon}</span>
                <span className="text-[10px] font-bold uppercase tracking-widest">{item.label}</span>
              </div>
              <span className="text-lg font-mono font-bold text-white tracking-tight">{item.value}</span>
            </div>
          ))}
        </div>

        {/* Подвал - Чистый и системный */}
        <div className="mt-8 pt-5 border-t border-slate-800 flex justify-between items-center text-[11px] font-mono text-slate-500">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-green-500/80"></div>
            <span>LATENCY: {results?.total_latency_ms || 0}ms</span>
          </div>
          <span className="opacity-60 uppercase">ID: {results?.calculation_id?.toString().slice(0, 8) || 'N/A'}</span>
        </div>
      </div>

      {/* Контейнер для визуалки - Высота зафиксирована для баланса */}
      <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden h-[540px] shadow-2xl relative">
        <div className="absolute top-4 left-4 z-10 pointer-events-none opacity-40">
           <span className="text-[9px] font-mono text-white uppercase tracking-[0.2em]">Live Simulation</span>
        </div>
        <OrbitVisualizer3D
          initialOrbit={initialOrbit}
          targetOrbit={targetOrbit}
          results={results}
        />
      </div>
    </div>
  );
};

export default ResultsSection;